export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_11-6879a7d5acd497d081fc8a292c89b6af.jpg";